module.exports = __webpack_public_path__ + "assets/stitch.38f4c660.svg";